webpackJsonp([48050446922739],{

/***/ 27:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Section = __webpack_require__(7);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(35);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapAdditionalImage = function mapAdditionalImage(_ref, index) {
		var imageSrc = _ref.imageSrc,
		    imageSrc2x = _ref.imageSrc2x;
		return _react2.default.createElement("img", { key: index, className: "pictureSectionImg border-radius-small", src: imageSrc, srcSet: imageSrc2x + " 2x", style: { marginTop: 10 } });
	};
	
	var PictureSectionWithCaption = function PictureSectionWithCaption(_ref2) {
		var _ref2$className = _ref2.className,
		    className = _ref2$className === undefined ? "" : _ref2$className,
		    imageSrc = _ref2.imageSrc,
		    imageSrc2x = _ref2.imageSrc2x,
		    caption = _ref2.caption,
		    _ref2$additionalImage = _ref2.additionalImages,
		    additionalImages = _ref2$additionalImage === undefined ? [] : _ref2$additionalImage;
	
	
		var additionalImagesRendered = additionalImages.map(mapAdditionalImage);
		return _react2.default.createElement(
			_Section2.default,
			{ className: "pictureSection has-mobile-gutter " + className + " text-align-center" },
			_react2.default.createElement(
				"span",
				{ className: "caption title font-size-med" },
				caption
			),
			_react2.default.createElement(
				"div",
				{ className: "desktop-max-width-large text-align-center" },
				_react2.default.createElement("img", { className: "pictureSectionImg border-radius-small", src: imageSrc, srcSet: imageSrc2x + " 2x" }),
				additionalImagesRendered
			)
		);
	};
	
	PictureSectionWithCaption.propTypes = {
		className: _propTypes2.default.string,
		imageSrc: _propTypes2.default.string.isRequired,
		imageSrc2x: _propTypes2.default.string.isRequired
	};
	
	exports.default = PictureSectionWithCaption;
	module.exports = exports["default"];

/***/ }),

/***/ 35:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 129:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.CheckoutMainContent = exports.CheckoutIntroSection = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PictureSectionWithCaption = __webpack_require__(27);
	
	var _PictureSectionWithCaption2 = _interopRequireDefault(_PictureSectionWithCaption);
	
	var _BaseIntroSection = __webpack_require__(15);
	
	var _BaseIntroSection2 = _interopRequireDefault(_BaseIntroSection);
	
	var _posting_ = __webpack_require__(328);
	
	var _posting_2 = _interopRequireDefault(_posting_);
	
	var _posting_3 = __webpack_require__(329);
	
	var _posting_4 = _interopRequireDefault(_posting_3);
	
	var _posting_5 = __webpack_require__(330);
	
	var _posting_6 = _interopRequireDefault(_posting_5);
	
	var _posting_7 = __webpack_require__(331);
	
	var _posting_8 = _interopRequireDefault(_posting_7);
	
	var _posting_9 = __webpack_require__(332);
	
	var _posting_10 = _interopRequireDefault(_posting_9);
	
	var _posting_11 = __webpack_require__(323);
	
	var _posting_12 = _interopRequireDefault(_posting_11);
	
	var _posting_13 = __webpack_require__(324);
	
	var _posting_14 = _interopRequireDefault(_posting_13);
	
	var _posting_15 = __webpack_require__(325);
	
	var _posting_16 = _interopRequireDefault(_posting_15);
	
	var _posting_17 = __webpack_require__(326);
	
	var _posting_18 = _interopRequireDefault(_posting_17);
	
	var _posting_19 = __webpack_require__(327);
	
	var _posting_20 = _interopRequireDefault(_posting_19);
	
	__webpack_require__(285);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Photo1 = function Photo1() {
		return _react2.default.createElement(
			"div",
			{ className: "introSectionPhoto desktop-max-width-large  text-align-center" },
			_react2.default.createElement(
				"div",
				{ className: "imgContainer" },
				_react2.default.createElement("img", { className: "post1Image border-radius-small", src: _posting_2.default, srcSet: _posting_12.default + " 2x" })
			),
			_react2.default.createElement(
				"span",
				{ className: "caption font-size-base font-family-open-sans" },
				"Various paths a user can take in the checkout flow depending on their various use cases."
			)
		);
	};
	
	var CheckoutIntroSection = exports.CheckoutIntroSection = function CheckoutIntroSection() {
		return _react2.default.createElement(
			_BaseIntroSection2.default,
			{
				className: "checkoutPage",
				mainText: "LinkedIn Job Posting Checkout Page",
				subText: "Guide our members through their job posting purchase",
				aboutText: "The LinkedIn consumer job posting checkout flow had not been updated to reflect the latest product offerings that LinkedIn had to offer. I worked with my PM closely to design the the checkout page to reflect changes in our product line as well as the variations that might happen through the process. Because job posting on LInkedIn can be a little confusing, we wanted to create a very clear outline of what they are purchasing, how much is due today, and how much will be due in the future. In additional, we wanted to drive more job posting sales so offering job packs was another way we were trying to drive sales. This redesign was launched in 2014 and is still in place today on the LinkedIn platform."
			},
			_react2.default.createElement(Photo1, null)
		);
	};
	
	var CheckoutMainContent = exports.CheckoutMainContent = function CheckoutMainContent() {
		return [_react2.default.createElement(_PictureSectionWithCaption2.default, {
			key: "1",
			imageSrc: _posting_4.default,
			imageSrc2x: _posting_14.default,
			caption: "Old job posting checkout page",
			className: "has-grey-background"
		}), _react2.default.createElement(_PictureSectionWithCaption2.default, {
			key: "2",
			imageSrc: _posting_6.default,
			imageSrc2x: _posting_16.default,
			caption: "Redesigned job posting checkout page"
		}), _react2.default.createElement(_PictureSectionWithCaption2.default, {
			key: "3",
			imageSrc: _posting_8.default,
			imageSrc2x: _posting_18.default,
			caption: "Repeat buyer flow"
		}), _react2.default.createElement(_PictureSectionWithCaption2.default, {
			key: "4",
			imageSrc: _posting_10.default,
			imageSrc2x: _posting_20.default,
			caption: "Spec documentation"
		})];
	};

/***/ }),

/***/ 285:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 323:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/posting_1.967108d5.jpg";

/***/ }),

/***/ 324:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/posting_2.a1a1d37b.jpg";

/***/ }),

/***/ 325:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/posting_3.9ec43aa0.jpg";

/***/ }),

/***/ 326:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/posting_4.ed2a1197.jpg";

/***/ }),

/***/ 327:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/posting_5.e774aebc.jpg";

/***/ }),

/***/ 328:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/posting_1.cef4277c.jpg";

/***/ }),

/***/ 329:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/posting_2.fd596371.jpg";

/***/ }),

/***/ 330:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/posting_3.afdca640.jpg";

/***/ }),

/***/ 331:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/posting_4.48000cba.jpg";

/***/ }),

/***/ 332:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/posting_5.20acb166.jpg";

/***/ }),

/***/ 140:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _BackToHomeHeader = __webpack_require__(14);
	
	var _BackToHomeHeader2 = _interopRequireDefault(_BackToHomeHeader);
	
	var _CheckoutPageSections = __webpack_require__(129);
	
	var _Footer = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CheckoutPage = function CheckoutPage() {
		return [_react2.default.createElement(_BackToHomeHeader2.default, { key: "header", title: "Job Posting Checkout", company: "LinkedIn" }), _react2.default.createElement(_CheckoutPageSections.CheckoutIntroSection, { key: "introSection" }), _react2.default.createElement(_CheckoutPageSections.CheckoutMainContent, { key: "mainContent" }), _react2.default.createElement(_Footer.NextProjectFooter, { key: "homeFooter", href: "/how-you-rank" })];
	};
	
	exports.default = CheckoutPage;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-checkout-js-1512d5b2a37d27e40b9c.js